import request from '@/axios'
export function fetch_user_list (customerId, from_user_type) {
  return request({
    url:`ClientUser/chat/fetch_user_list/${from_user_type}`,
    method: 'GET'
  })
}

export function fetch_user_list_1 (customerId, from_user_type, page_no) {
  return request({
    url:`ClientUser/fetch_user_list/${from_user_type}/${customerId}?page=${page_no}`,
    method: 'GET'
  })
}

export function sendSaveEmail (customerId, emailPayload) {
  return request({
    url:`ClientUser/communication/email/send/${customerId}`,
    method: 'POST',
    data: emailPayload
  })
}

export function getEmailInboxList (customerId, page) {
  return request({
    url:`ClientUser/communication/email/list/INBOX/${customerId}?page=${page}`,
    method: 'POST'
  })
}

export function getEmailSentList (customerId, page) {
  return request({
    url:`ClientUser/communication/email/list/SENT/${customerId}?page=${page}`,
    method: 'POST'
  })
} 

export function getEmailDraftList (customerId, page) {
  return request({
    url:`ClientUser/communication/email/list/DRAFT/${customerId}?page=${page}`,
    method: 'POST'
  })
}


export function deleteInboxEmail (customerId, email_ids) {
  return request({
    url:'ClientUser/communication/email/delete/INBOX',
    method: 'POST',
    data: email_ids
  })
}
  
export function deleteSentEmail (customerId, email_ids) {
  return request({
    url:'ClientUser/communication/email/delete/SENT',
    method: 'POST',
    data: email_ids
  })
}
  
export function deleteDraftEmail (customerId, email_ids) {
  return request({
    url:`ClientUser/communication/email/delete/DRAFT`,
    method: 'POST',
    data: email_ids
  })
}

export function getSentEmailThread (customer_id, email_id) {
  return request({
    url: `ClientUser/communication/email/view/SENT/${customer_id}`,
    method: 'POST',
    data: email_id
  })
}

export function getInboxEmailThread (customer_id, email_id) {
  return request({
    url: `ClientUser/communication/email/view/INBOX/${customer_id}`,
    method: 'POST',
    data: email_id
  })
}

export function getCommunicationSettings (customer_id) {
  return request({
    url: `/communication/setting/${customer_id}`,
    method: 'GET'
  })
}

export function updateCommunicationSettings (customer_id, settings_payload) {
  return request({
    url: `/communication/setting/${customer_id}`,
    method: 'POST',
    data:settings_payload
  })
}

export function sendSMS (customerId, payload) {
  return request({
    url:`/communication/sms/send/${customerId}`,
    method: 'POST',
    data: payload
  })
}

export function deleteSMS (customerId, payload) {
  return request({
    url:`/communication/sms/delete/${customerId}/SENT`,
    method: 'POST',
    data: payload
  })
}

export function fetchSMSLog (customerId, payload) {
  return request({
    url:`/communication/sms/list/${customerId}/SENT`,
    method: 'POST',
    data: payload
  })
}
